import axios from 'axios'

let login = {}
login.userlogin = params => {
  return axios.post('/sys/sysuser/login', params)
}
login.userlogout = params => {
  return axios.post('/sys/sysuser/logout', {params})
}
login.changePwd = params => {
  return axios.post('/sys/user/originalPassword', params)
}
export default login



// WEBPACK FOOTER //
// ./src/api/login.js